// extracted by mini-css-extract-plugin
export var growableInput = "_83-0";
export var tagContainer = "_83-2";
export var textInput = "_83-1";